import { JoinTask } from './joinTask.types'

export const createJoinTask = ({
  name,
  taskReferenceName,
  inputParameters,
  joinOn
}: Pick<
  JoinTask,
  'name' | 'taskReferenceName' | 'inputParameters' | 'joinOn'
>): JoinTask => {
  return {
    type: 'JOIN',
    name,
    taskReferenceName,
    inputParameters,
    joinOn
  }
}
